import { useEffect } from "react";

/*
 * Lightweight SEO hook — updates document.title, meta description,
 * canonical URL and OG tags on every route change. Works for CRA SPAs
 * without needing react-helmet.
 */
export function useSEO({ title, description, keywords, canonicalPath, image, type = "website" }) {
  useEffect(() => {
    const origin = "https://style-venvay.emergent.host";
    const fullTitle = title ? `${title} · Venvay` : "Venvay — Custom T-Shirt Printing India";
    document.title = fullTitle;

    const setMeta = (name, content, isProp = false) => {
      if (!content) return;
      const attr = isProp ? "property" : "name";
      let tag = document.head.querySelector(`meta[${attr}="${name}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attr, name);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    if (description) setMeta("description", description);
    if (keywords) setMeta("keywords", keywords);
    setMeta("og:title", fullTitle, true);
    setMeta("og:description", description || "Premium custom t-shirt printing brand in India.", true);
    setMeta("og:type", type, true);
    if (image) setMeta("og:image", image, true);
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", description || "Premium custom t-shirt printing brand in India.");
    if (image) setMeta("twitter:image", image);

    // Canonical
    let canon = document.head.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.setAttribute("rel", "canonical");
      document.head.appendChild(canon);
    }
    canon.setAttribute("href", origin + (canonicalPath || window.location.pathname));

    // og:url
    setMeta("og:url", origin + (canonicalPath || window.location.pathname), true);
  }, [title, description, keywords, canonicalPath, image, type]);
}
